<template>
  <div class="row">
    <div v-show="editable&&!disabled" class="col-12">
      <q-btn-group outline class="float-right">
        <c-btn 
          :isSubmit="isComplete"
          :url="completeUrl"
          :param="saveProcess"
          mappingType="PUT"
          :label="'공정[' + process.processName + '] 평가완료'" 
          icon="check"
          @beforeAction="completeProcess"
          @btnCallback="completeProcessCallback" />
      </q-btn-group>
    </div>
    <div class="col-12">
      <c-tab
        type="tabcard"
        align="left"
        title="도면"
        :tabItems.sync="process.draws"
        :inlineLabel="true"
        v-model="tab"
      >
        <template v-slot:default="tab">
          <component
            :is="tab.component"
            :key="tab.componentKey"
            :draw.sync="tab.draw"
            :process.sync="process"
            :param="param"
            :disabled="disabled"
            @research="research"
          />
        </template>
      </c-tab>
    </div>
  </div>
</template>

<script>
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'hazop-action-detail',
  props: {
    process: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정명
        ramProcessAssessStepCd: '',  // 평가진행상태
        processExplainFeature: '',  // 공정 특징 설명
        assessDeptCd: '',  // 평가 부서 코드
        assessUserId: '',  // 평가 담당자
        assessUserName: '',  // 평가 담당자
        draws: [],
      }),
    },
    param: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',
        ramStepCd: '',
      }),
    },
  },
  data() {
    return {
      editable: true,
      tab: '',
      completeUrl: '',
      isComplete: false,
      saveProcess: {
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정명
        ramProcessAssessStepCd: '',  // 평가진행상태
        processExplainFeature: '',  // 공정 특징 설명
        assessDeptCd: '',  // 평가 부서 코드
        assessUserId: '',  // 평가 담당자
        draws: [],
      }
    };
  },
  computed: {
    disabled() {
      return !(this.param.ramStepCd === 'RHS000005' || this.param.ramStepCd == 'RHS000010') || this.process.ramProcessAssessStepCd === 'RPA0000005'
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.completeUrl = transactionConfig.ram.assessProcess.complete.url;
      // code setting
      // list setting
      this.setDraw();
    },
    setDraw() {
      if (this.process && this.process.draws) {
        this.tab = this.process.draws[0].psiDiagramId
      }
    },
    completeProcess() {
      // 도면 별 노드에 시나리오가 하나 이상 등록되었는지?
      // 화면에서 추가는 하고 저장을 하지 않았을 시에 해당 데이터도 일괄 저장 처리
      // 저장 처리 후 callback에서 process 목록 재조회
      let isProgress = true;
      this.$_.forEach(this.process.draws, draw => {
        this.$_.forEach(draw.nodes, node => {
          if (!node.hazopScenarios || node.hazopScenarios.length === 0) {
            isProgress = false
            window.getApp.$emit('ALERT', {
              title: '안내', // 안내
              message: '도면[' + draw.diagramTitle + '] / 노드 [' + node.nodeTitle + ']에 등록된 시나리오가 없습니다.',
              type: 'warning', // success / info / warning / error
            });
            return false;
          }
        });
        if (!isProgress) {
          return false;
        }
      })

      if (isProgress) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '완료하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.process.chgUserId = this.$store.getters.user.userId
            this.process.ramProcessAssessStepCd = 'RPA0000005';

            this.saveProcess = this.$_.cloneDeep(this.process);
            this.$_.forEach(this.saveProcess.draws, draw => {
              delete draw.draw
            })

            this.isComplete = !this.isComplete
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    completeProcessCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('assessComplete', _result.data)
    },
    research() {
      this.$emit('research', 'scenario')
    }
  }
};
</script>
